import { styled } from '@linaria/react';

import { IconButtonWrapper } from '~components/IconButton/IconButton.styles';
import { P } from '~components/Typography';

export const Container = styled.div`
	position: relative;
	grid-column-start: 1;
	grid-column: 1 / -1;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 24px;
	padding: 24px 16px 24px 24px;
	background: linear-gradient(
		180deg,
		rgba(47, 41, 64, 1) 0%,
		rgba(47, 41, 64, 0.1) 100%
	);
	border-radius: 16px;

	@media screen and (max-width: 600px) {
		margin-top: 10px;
	}

	@media screen and (max-width: 1200px) {
		margin-left: 20px;
		margin-right: 20px;
		padding: 20px 16px 20px 20px;
	}

	& > ${IconButtonWrapper} {
		position: absolute;
		right: 0;
		top: 0;
	}
`;

export const DescriptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	p {
		text-align: start;
	}
`;

export const NSFWSwitchButton = styled.button`
	cursor: pointer;
	font-size: 14px;
	color: var(--brand-pink-light);
	font-weight: 500;
	text-decoration: underline;
`;

export const CloseButtonWrapper = styled.div`
	position: absolute;
	right: 24px;
	top: 20px;
	width: 20px;
	height: 20px;
	color: var(--color-white-05);
	cursor: pointer;

	@media screen and (max-width: 600px) {
		top: 22px;
		right: 18px;
	}
`;

export const Title = styled(P)`
	font-weight: 600;
	font-size: 18px;
	text-align: start;
	@media screen and (max-width: 600px) {
		font-size: 16px;
	}
`;
